import { render, staticRenderFns } from "./AccountAdminMenu.vue?vue&type=template&id=bfe92900&"
import script from "./AccountAdminMenu.vue?vue&type=script&lang=js&"
export * from "./AccountAdminMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports